// Config
import { FEATURE_KEYS } from '~fpu/config/optimizely';

// Hooks
import { useFeatureFlag } from '~fpu/shared/hooks/useFeatureFlag';
import { useOrganizationFeatureEntitlement } from '~fpu/shared/hooks/useOrganizationFeatureEntitlement';
import { useOrganizationId } from './useOrganizationId';

const BUDGET_WORKSHOP_FEATURE_KEY = 'budget_workshop';

// Remove once the fpu-organizations-service seed migration backfills these two orgs into
// feature_entitlements — until then, dropping this array would revoke their access.
const EARLY_ACCESS_ORGANIZATION_IDS = [
  'CRUSADE-AMBASSADOR12',
  'CRUSADE-4TEAMMEMBERS'
];

function useBudgetWorkshopEnabled() {
  const {
    isEnabled: isFeatureFlagEnabled,
    isFetched: isFeatureFlagFetched,
    isLoading: isFeatureFlagLoading,
    isError: isFeatureFlagError,
    error: featureFlagError
  } = useFeatureFlag(FEATURE_KEYS.FPU_BUDGET_WORKSHOP);
  const organizationId = useOrganizationId();
  const {
    data: isEligible,
    isFetched: isEntitlementFetched,
    isLoading: isEntitlementLoading,
    isError: isEntitlementError,
    error: entitlementError
  } = useOrganizationFeatureEntitlement(
    organizationId,
    BUDGET_WORKSHOP_FEATURE_KEY
  );

  const entitlementApplies = !!organizationId;
  const isEarlyAccessOrg =
    entitlementApplies &&
    EARLY_ACCESS_ORGANIZATION_IDS.includes(organizationId);

  const isBudgetWorkshopEnabled =
    isFeatureFlagEnabled || isEarlyAccessOrg || !!isEligible;

  return {
    isEnabled: isBudgetWorkshopEnabled,
    isFetched:
      isFeatureFlagFetched && (!entitlementApplies || isEntitlementFetched),
    isLoading:
      isFeatureFlagLoading || (entitlementApplies && isEntitlementLoading),
    isError: isFeatureFlagError || (entitlementApplies && isEntitlementError),
    error: featureFlagError || (entitlementApplies ? entitlementError : null)
  };
}

export { useBudgetWorkshopEnabled };
